/** @jsx jsx */

import React, { Fragment as _, memo, useMemo } from 'react';
import { css, jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column, Button, Box } from '@chameleoncreator/creator-ui';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import SVG from 'components/lib/SVG';
import Media from 'components/lib/Media';
import { interactionContext } from './interactionContext';
import Container from 'components/Layouts/ContainerLogical';
import getBlockById from 'services/apiHelpers/getBlockById';
import continueBtn from '../ContinueBtn/continueBtn_v2';
import { Block } from '@chameleoncreator/creator-app';
import IELayout from 'components/Layouts/IELayout';
import TopicPortalContainer from './TopicPortalContainer';
import shouldUpdate from 'services/shouldUpdate';

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  Text: ({ children, ...props }) => (
    <EditableText {...{ ...props, className: 'flipcard-text' }} />
  ),
  TopicPortalContainer,
  Media,
  TwoColumnLayout: TwoColumnLayout,
  SingleColumnLayout: SingleColumnLayout,
  ContinueButton: continueBtn,
  ...IELayout(interactionContext),
};

const TopicPortalDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider
        value={{ ...interactionBlock, updateItemsSeen: null }}
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </interactionContext.Provider>
    </Container>
  );
}, shouldUpdate);

// const TopicPortalDisplay = props => {
//   const interactionBlock = getBlockById(props.blockId);

//   const container = (
//     <Container
//       id={interactionBlock.id}
//       key={interactionBlock.id}
//       {...interactionBlock.props}
//       {...props}
//     >
//       <interactionContext.Provider
//         value={{ ...interactionBlock, updateItemsSeen: null }}
//       >
//         {(interactionBlock.children as Block[]).map(child => {
//           return renderBlock(child, Components);
//         })}
//       </interactionContext.Provider>
//     </Container>
//   );

//   return window.dev()
//     ? container
//     : useMemo(() => {
//         // console.log('topicPortal renders');
//         return container;
//       }, [props.isOpen, interactionBlock.props.lockDown]);

//   return (
//     <Container
//       id={interactionBlock.id}
//       key={interactionBlock.id}
//       {...interactionBlock.props}
//       {...props}
//     >
//       <interactionContext.Provider
//         value={{ ...interactionBlock, updateItemsSeen: null }}
//       >
//         {(interactionBlock.children as Block[]).map(child => {
//           return renderBlock(child, Components);
//         })}
//       </interactionContext.Provider>
//     </Container>
//   );
// };

export default TopicPortalDisplay;
